export function validateCNPJ(cnpj: string): boolean {
  // Remove caracteres não numéricos
  cnpj = cnpj.replace(/[^\d]+/g, '');

  // Verifica se tem 14 dígitos
  if (cnpj.length !== 14) return false;

  // Elimina CNPJs inválidos conhecidos (todos os dígitos iguais)
  if (/^(\d)\1{13}$/.test(cnpj)) return false;

  // Cálculo do primeiro dígito verificador
  let soma = 0;
  let pesos = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  
  for (let i = 0; i < 12; i++) {
    soma += parseInt(cnpj.charAt(i), 10) * pesos[i];
  }

  let resultado = soma % 11;
  let digito1 = (resultado < 2) ? 0 : 11 - resultado;

  if (parseInt(cnpj.charAt(12), 10) !== digito1) return false;

  // Cálculo do segundo dígito verificador
  soma = 0;
  pesos = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  
  for (let i = 0; i < 13; i++) {
    soma += parseInt(cnpj.charAt(i), 10) * pesos[i];
  }

  resultado = soma % 11;
  let digito2 = (resultado < 2) ? 0 : 11 - resultado;

  if (parseInt(cnpj.charAt(13), 10) !== digito2) return false;

  return true;
}
